import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Modal from 'react-modal';
import Spinner from 'react-spinkit';
import CardLogoList from '../payment/logoList';
import PaymentMethodForm from '../payment/form';
import { makePrimaryCard, removeCard } from '../payment/actions';

const renderCardRow = (card, primaryCard, makePrimary, remove) => {
  const dasherizedBrand = card.brand.toLowerCase().replace(' ', '-');
  const logoClass = ['cc-row__logo', dasherizedBrand].join(' ');
  const isPrimary = primaryCard && primaryCard.id === card.id;

  return (
    <div key={card.id} className="cc-row">
      <div className="cc-row__logo-container">
        <div className={logoClass} />
      </div>
      <div className="cc-row__details">
        <div className="row">
          <div className="col-xs-4">
            <div className="row start-xs">
              <div className="col-xs">
                <span className="hidden-sm">••••</span>
                <span className="visible-sm-inline">{card.brand}</span>{' '}
                <span>{card.last4}</span>
              </div>
            </div>
          </div>
          <div className="col-xs">
            <div className="row end-xs">
              <div className="col-xs">
                {isPrimary ? (
                  <span className="cc-row__primary">Primary</span>
                ) : (
                  <button
                    className="btn-small cc-row__btn"
                    onClick={() => makePrimary(card.id)}
                  >
                    Make Primary
                  </button>
                )}
                <button
                  className="btn-small cc-row__btn"
                  onClick={() => remove(card)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false, loading: false, cardToDelete: null };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.makePrimary = this.makePrimary.bind(this);
    this.remove = this.remove.bind(this);
    this.confirmRemove = this.confirmRemove.bind(this);
    this.closeRemoveModal = this.closeRemoveModal.bind(this);
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  makePrimary(id) {
    this.setState({ loading: true });
    this.props.makePrimaryCard(id).finally(() => {
      this.setState({ loading: false });
    });
  }

  remove(card) {
    this.setState({ cardToDelete: card });
  }

  confirmRemove() {
    this.setState({ loading: true });
    this.props.removeCard(this.state.cardToDelete.id).finally(() => {
      this.setState({ loading: false, cardToDelete: null });
    });
  }

  closeRemoveModal() {
    this.setState({ cardToDelete: null });
  }

  render() {
    const primaryCard = this.props.primaryCardId
      ? _.find(this.props.cards, { id: this.props.primaryCardId })
      : _.first(this.props.cards);

    return (
      <div>
        {this.state.loading && (
          <div className="loading-container row center-xs middle-xs">
            <Spinner spinnerName="three-bounce" noFadeIn />
          </div>
        )}

        {this.props.cards.map(card => {
          return renderCardRow(
            card,
            primaryCard,
            this.makePrimary,
            this.remove
          );
        })}

        <div className="row">
          <div className="col-xs-12">
            <button
              type="button"
              className="btn-primary btn-block"
              onClick={this.openModal}
            >
              Add Card
            </button>
          </div>
        </div>

        <Modal
          overlayClassName="modal-overlay"
          className="modal-content"
          isOpen={this.state.showModal}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick={true}
          contentLabel="Payment Info"
          ariaHideApp={false}
        >
          <div className="payment-modal__container">
            <div className="clearfix">
              <CardLogoList className="right" />
              <h2 className="payment-modal__header">Payment Info</h2>
            </div>
            <PaymentMethodForm
              onSuccess={this.closeModal}
              cardInputClass="form-field stripe-input-container"
              btnContainerClass="col-xs-12"
              btnClass="btn-primary btn--full-width"
            />
          </div>
        </Modal>

        <Modal
          overlayClassName="modal-overlay"
          className="modal-content"
          isOpen={!!this.state.cardToDelete}
          onRequestClose={this.closeRemoveModal}
          shouldCloseOnOverlayClick={true}
          contentLabel="Remove Credit Card"
          ariaHideApp={false}
        >
          {this.state.cardToDelete && (
            <p>
              Are you sure you want to remove {this.state.cardToDelete.brand}{' '}
              {this.state.cardToDelete.last4}?
            </p>
          )}
          <div className="row center-xs">
            <div className="col-xs-4">
              <button
                className="btn-small btn-secondary"
                onClick={this.closeRemoveModal}
              >
                Cancel
              </button>
            </div>
            <div className="col-xs-4">
              <button
                className="btn-small btn-primary"
                onClick={this.confirmRemove}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.payment };
}

export default connect(mapStateToProps, { makePrimaryCard, removeCard })(
  Payment
);



// WEBPACK FOOTER //
// ./shared/components/account/payment.js